<template>
  <div class="question-item-component mb-3">
    <div class="d-flex align-items-center justify-content-bee">
      <button
        class="btn btn-header p-0 m-0"
        @click.prevent="editing = !editing"
      >
        <i class="fa fa-grip-vertical handle lead fs-14"></i>
        <h6 class="m-0 p-0" :class="{ 'pl-6': editing }">
          {{ item.question }}
        </h6>
        <div class="d-flex"></div>
      </button>
      <div v-if="editing" class="d-flex align-items-center justify-content-end">
        <button type="button" class="btn btn-sm p-0" @click.prevent="onRemove">
          <i class="icon-filled-trash text-danger"></i>
        </button>
      </div>
    </div>
    <template v-if="editing">
      <hr />

      <form-group
        v-model="item.question"
        id="question"
        label="Pergunta*"
        placeholder="Digite uma pergunta frequente"
      />

      <form-group
        textarea
        v-model="item.answer"
        id="answer"
        label="Resposta*"
        type="textarea"
        placeholder="Digite a resposta para a pergunta"
      />
      <small class="fs-13">
        Tire as dúvidas mais frequentes dos seus alunos com estas respostas.
      </small>

      <div class="d-flex justify-content-end">
        <button
          class="btn btn-new-outline-primary btn-sm px-6 py-3 mt-6 mb-3"
          :disabled="!isValid"
          @click="submit"
        >
          <b-spinner v-if="loading" variant="primary" small />
          <span v-else>Salvar</span>
        </button>
      </div>

      <confirmation
        iconType="warning"
        title="Aviso"
        cancelButtonText="Cancelar"
        v-model="dialog_remove"
        confirmButtonClass="btn-danger"
        confirmButtonText="Confirmar"
        :text="`Deseja mesmo excluir a pergunta: ${item.question}`"
        @confirm="submitDelete"
        @cancel="dialog_remove = false"
      />
    </template>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
    index: Number
  },
  mounted() {
    if (!this.item?.id) {
      this.editing = true;
    }
  },
  data: () => ({ loading: false, editing: false, dialog_remove: false }),
  computed: {
    isValid() {
      return this.item.question.length && this.item.answer.length;
    }
  },
  methods: {
    cancelEdit() {
      this.$emit("update");
      this.editing = false;
    },
    onRemove() {
      if (this.item.id) {
        this.dialog_remove = true;
      } else {
        this.$emit("remove", this.index);
      }
    },
    submit() {
      if (this.loading) return;

      const payload = {
        product_id: this.$route.params.id,
        ...this.item,
        sort: this.index
      };

      let action = "membersSetup/postFAQ";

      if (this.item.id) {
        action = "membersSetup/putFAQ";
        delete payload.company_id; // unecessary field
      }

      if (!this.item.question.length) {
        this.$message.warning(`Digite o título da pergunta ${this.index + 1}.`);
        return;
      }

      if (!this.item.answer.length) {
        this.$message.warning(
          `Digite o título a resposta da pergunta ${this.index + 1}.`
        );
        return;
      }

      this.loading = true;
      this.$store
        .dispatch(action, payload)
        .then(response => {
          this.$message.success(`A pergunta ${this.index + 1} foi salva!`);
          this.editing = false;
          const faqs = [...this.$store.state.membersSetup.faqs];
          faqs.splice(this.index, 1, response.data);
          this.$store.commit("membersSetup/setFaqs", faqs);
        })
        .catch(() => {
          this.$message.error(
            `Não foi possível salvar a pergunta ${this.index + 1}!`
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitDelete() {
      this.$store
        .dispatch("membersSetup/deleteFAQ", this.item.id)
        .then(() => {
          this.$message.success(`A pergunta ${this.index + 1} foi deletada!`);
          this.$store.commit(
            "membersSetup/setFaqs",
            this.$store.state.membersSetup.faqs.filter(
              f => f.id !== this.item.id
            )
          );
        })
        .catch(() => {
          this.$message.error(
            `Não foi possível deletar a pergunta ${this.index + 1}!`
          );
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.question-item-component {
  border-radius: 4px;
  border: 1px solid var(--l-neutral-113);
  background: var(--l-elevation-12);
  padding: 16px 24px;
  transition: 0.3s border;

  &:hover {
    border: 1px solid rgba(207, 174, 255, 0.86);
  }

  .btn-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 20px;
    .fa-grip-vertical {
      color: #9b9db0db;
    }

    h6 {
      color: var(--l-neutral-105, rgba(38, 36, 50, 0.93));
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }
  }

  .icon-drag-indicator {
    color: var(--l-neutral-2);
  }

  .icon-filled-trash {
    font-size: 24px;
    width: 22px;
    line-height: 16px;
  }

  .lead {
    cursor: grab;
  }

  small {
    color: var(--l-neutral-45, rgba(87, 88, 107, 0.88));
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  ::v-deep .form-control:disabled {
    background-color: transparent !important;
    border-color: transparent !important;
  }
}
</style>
